/* istanbul ignore next */
const gaMiddleware = store => next => action => {
  try {
    if (
      action.type === "@@router/LOCATION_CHANGE" &&
      store.getState().router.location
    ) {
      const newRoute = action.payload.pathname
      const oldRoute = store.getState().router.location.pathname
      /* istanbul ignore next */
      if (oldRoute !== newRoute && window.gtag !== undefined)
        window.gtag("event", "page_view", { page_location: newRoute })
    }
  } catch (e) {
    /* istanbul ignore next */
    console.warn(`Error in gaMiddleware: ${e}`)
  } finally {
    next(action)
  }
}

export default gaMiddleware
